const image_baseUrl = process.env.VUE_APP_IMAGE_URL;

export default {
  appurl: image_baseUrl,
  basepath: image_baseUrl + "img/",
  user: image_baseUrl + "media/User/original/",
  no_image: image_baseUrl + "img/no-image.png",
};
